module.exports = __webpack_public_path__ + "media/V37.b48f9be9.mp4";